import ebsu from './EBS.png';
import schoolBuilding from './schoolBuilding.png';
import slide1 from './slide1.png';
import slide2 from './slide2.png';
import eLogo from './E-Grade.png';
import adminIcon from './adminIcon.png';
import repoIcon from './repoIcon.png';
import studentIcon from './studentIcon.png';
import questionPaper from './paper.png';
import student from './student.png';



const Images = {
    ebsu,
    schoolBuilding,
    slide1,
    slide2,
    eLogo,
    adminIcon,
    repoIcon,
    studentIcon,
    questionPaper,
    student,
}
export default Images;